(function() {
  'use strict';

  var KLAVIYO_PUBLIC_KEY = 'SbKUWL';
  var KLAVIYO_NEWSLETTER_LIST_ID = 'YmUnPY';
  var KLAVIYO_REVISION = '2024-10-15';

  var form = document.getElementById('footer-newsletter-form');
  if (!form) return;

  var emailInput = form.querySelector('[data-newsletter-email]');
  var honeypot = form.querySelector('[data-newsletter-hp]');
  var submitBtn = form.querySelector('[data-newsletter-submit]');
  var errorEl = form.querySelector('[data-newsletter-error]');
  var formInner = form.querySelector('[data-newsletter-fields]');
  var successEl = form.querySelector('[data-newsletter-success]');

  form.addEventListener('submit', function(e) {
    e.preventDefault();

    // Honeypot check — fake success so bots don't know
    if (honeypot && honeypot.value !== '') {
      formInner.style.display = 'none';
      successEl.style.display = 'block';
      return;
    }

    var email = emailInput.value.trim();

    // Client-side validation
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      errorEl.textContent = 'Please enter a valid email address.';
      errorEl.style.display = 'block';
      return;
    }

    errorEl.style.display = 'none';
    submitBtn.disabled = true;
    submitBtn.textContent = 'Sending\u2026';

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_PUBLIC_KEY, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/vnd.api+json',
        'revision': KLAVIYO_REVISION
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Footer signup',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email
                }
              }
            }
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: KLAVIYO_NEWSLETTER_LIST_ID
              }
            }
          }
        }
      })
    })
    .then(function(res) {
      if (!res.ok) throw new Error('Klaviyo responded ' + res.status);
      formInner.style.display = 'none';
      successEl.style.display = 'block';
    })
    .catch(function(err) {
      console.error('Footer newsletter error:', err);
      errorEl.textContent = 'Something went wrong. Please try again.';
      errorEl.style.display = 'block';
      submitBtn.disabled = false;
      submitBtn.textContent = 'Subscribe';
    });
  });
})();
